import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'

export const OptionsWrapper = styled.div`
  display: flex;
  max-width: 1024px;
  margin: 0 auto;
  padding: 8px 8px 8px 36px;
  align-items: center;
  gap: 4px;
  border-radius: 36px;
  background: #fff;
  box-shadow: 0px 4px 24px 0px rgba(9, 55, 105, 0.08);
  width: 340px;
  min-height: 56px;
  contain: layout;

  ${mediaUp('md')} {
    max-width: 1024px;
    width: unset;
    gap: 12px;
    min-height: 68px;
  }

  ${mediaUp('lg')} {
    gap: 36px;
    min-height: 72px;
  }
`

export const MobileSearchBoxWrapper = styled.div`
  box-sizing: border-box;
`

export const MobileOptionsWrapper = styled.div`
  display: grid;
  width: 100%;
  margin: 0 auto;
`

export const LocationInputWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 8px 0 8px 18px;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background: #fff;
  color: #0b4684;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
  touch-action: manipulation;
  opacity: 64%;
`

export const ModalOverlay = styled.div`
  background: #fff;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  overflow: hidden;
  display: grid;
  grid-template-rows: 1fr auto;
`

export const ModalContent = styled.div`
  padding: 20px;
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ModalTitle = styled.h2`
  color: #093769;
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
`

export const RecentSearchesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
`

export const RecentSearchesTitle = styled.span`
  color: #6c7075;
  font-family: Nunito;
  font-size: 12px;
  font-weight: 600;
`

export const SearchItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  strong {
    font-weight: bold;
    color: #0b4684;
  }
`

export const SearchItem = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0;

  span {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 8px;
    text-align: left;
    font-weight: 400;
  }
  button {
    margin-left: auto;
  }
`

export const BottomSection = styled.div`
  background: #fff;
  display: flex;
  width: 100vw;
  position: fixed;
  bottom: calc(20px + max(env(safe-area-inset-bottom, 0px), 10px));
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`

export const DesktopWrapper = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`

export const MobileWrapper = styled.div`
  display: block;

  @media (min-width: 768px) {
    display: none;
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #dfe7f1;
  margin: 8px 0;
`
